import type { FC } from 'react'
import cn from 'classnames'
import Image from 'next/image'
import { emptyImagePlaceholder } from 'constants/image'
import s from './post-image.module.css'
import type { PostImageProps } from '.'

const ProductImage: FC<PostImageProps> = ({
  imageUrl,
  alt,
  className,
  width = 240,
  height = 240,
  quality = 80,
  ...props
}) => (
  <Image
    alt={alt}
    src={imageUrl || emptyImagePlaceholder}
    width={width}
    height={height}
    quality={quality}
    layout="responsive"
    className={cn(s.root, className)}
    {...props}
  />
)

export default ProductImage
